<template>
    <div id="user-app-prizes">
        <div class="prizes-title">Nagradna igra</div>
        <animated-number class="user-points" v-if="points !== null" v-bind:value="points" v-bind:round="true" v-bind:duration="800" />
        <div class="user-points" v-else>-</div>
        <div class="enter-code">Unesi kod</div>
        <div class="prize-code-inputs">
            <input class="user-app-code-input-field" type="text" maxlength=1 v-model="first" v-on:keyup="moveToNext(1)" />
            <input class="user-app-code-input-field" type="text" maxlength=1 v-model="second" v-on:keyup="moveToNext(2)" />
            <input class="user-app-code-input-field" type="text" maxlength=1 v-model="third" v-on:keyup="moveToNext(3)" />
            <input class="user-app-code-input-field" type="text" maxlength=1 v-model="fourth" v-on:keyup="moveToNext(4)" />
            <input class="user-app-code-input-field" type="text" maxlength=1 v-model="fifth" v-on:keyup="moveToNext(5)" />
            <input class="user-app-code-input-field" type="text" maxlength=1 v-model="sixth" v-on:keyup="sendRequestIfAllFilled" />
        </div>
        <div class="added-points" v-bind:style="{visibility: pointsAdded > 0 ? 'visible' : 'hidden'}">
            Dodano {{pointsAdded}} bodova.
        </div>
        <div class="subtitle">
            Achievementi
        </div>
        <div class="achievements-wrapper">
            <div v-bind:class="['achievement-box', userAchievementIds.indexOf(achievement.id) !== -1 ? 'fulfilled' : 'not-fulfilled']" v-for="achievement in achievements" v-bind:key="achievement.id">
                <div class="is-fulfilled">
                    <img class="unlocked-icon" v-bind:src="getAchievementUnlockedIcon(achievement.name)" />
                    <img class="locked-icon" v-bind:src="getAchievementLockedIcon(achievement.name)" />
                    <img class="fulfilled-mark" src="../../assets/app-icons/prizes/checkmark.png" /></div>
                <div class="achievement-name">{{achievement.name}}</div>
                <div class="achievement-description">{{achievement.description}}</div>
                <div class="achievement-points">
                    <img class="achievement-star" src="../../assets/app-icons/navigation/prizes.svg" />
                    <span>{{achievement.points}}</span>
                </div>
            </div>
        </div>
        <template v-if="eventsAvailableForSurvey && eventsAvailableForSurvey.length">
            <div class="subtitle">Ankete</div>
            <div v-on:click="openSurveyModal(event)" class="event-for-survey" v-for="event in eventsAvailableForSurvey" v-bind:key="event.id">
                <div>{{event.name}} ({{event.type === 'Lecture' ? 'Predavanje' : event.type === 'Workshop' ? 'Radionica' : event.type === 'FlyTalk' ? 'Fly talk' : 'Campfire talk'}})</div>
                <span v-for="(eventUser, index) in event.eventUsers" v-bind:key="eventUser.userId">
                    {{ eventUser.user.firstName }} {{ eventUser.user.lastName }}<span v-if="eventUser.user && eventUser.user.lecturerTitle"> ({{ eventUser.user.lecturerTitle }})</span><span v-if="index !== event.eventUsers.length - 1">, </span>
                </span>
            </div>
        </template>
        <div class="subtitle">
            Nagrade
        </div>
        <div class="prizes-wrapper">
            <div class="prize">
                <img src="../../assets/app-icons/prizes/dells.jpg" />
                <div>Monitor DELL S-series 24"</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/sennheisergsp500.jpg" />
                <div>Sennheiser GSP 500</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/xiaomimia2.jpg" />
                <div>Xiaomi Mi A2</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/logitechz337.jpg" />
                <div>Logitech Z337 Bluetooth</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/sennheiser430.jpg" />
                <div>Sennheiser HD 4.30G</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/logitechg603.jpg" />
                <div>Logitech G603</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/samsung860evo.jpeg" />
                <div>Samsung 860 EVO 250GB</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/msthunderpro.jpeg" />
                <div>MS Thunder Pro</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/roccathorde.jpg" />
                <div>ROCCAT Horde</div>
            </div>
            <div class="prize">
                <img src="../../assets/app-icons/prizes/adata.jpg" />
                <div>ADATA HDD 2TB</div>
            </div>
        </div>
        <SurveyModal v-if="surveyModalVisible" v-bind:event="eventForModal" v-on:close="surveyModalVisible = false" v-on:submit="submitSurvey" />
    </div>
</template>

<script>
    import AnimatedNumber from "animated-number-vue";
    import SurveyModal from '@/components/app/SurveyModal.vue';

    export default {
        name: 'Prizes',
        components: {
            AnimatedNumber,
            SurveyModal
        },
        data() {
            return {
                points: null,
                pointsAdded: 0,
                first: '',
                second: '',
                third: '',
                fourth: '',
                fifth: '',
                sixth: '',
                achievements: [],
                userAchievementIds: [],
                eventsAvailableForSurvey: [],
                surveyModalVisible: false,
                eventForModal: {}
            }
        },
        methods: {
            moveToNext: function(nextIndex) {
                let inputFields = document.getElementsByClassName('user-app-code-input-field');
                if(inputFields[nextIndex-1].value.length)
                    inputFields[nextIndex].focus();
            },
            sendRequestIfAllFilled: function() {
                if(!this.first.length || !this.second.length || 
                    !this.third.length || !this.fourth.length || 
                    !this.fifth.length || !this.sixth.length)
                    return;

                if(this.first.length !== 1 || this.second.length !== 1 ||
                    this.third.length !== 1 || this.fourth.length !== 1 ||
                    this.fifth.length !== 1 || this.sixth.length !== 1)
                    return;
                
                let wholeCode = (this.first + this.second + this.third + this.fourth + this.fifth + this.sixth).toUpperCase();
                this.$axios.post(`${this.$API_URL}/user/enter-code`, {
                        code: wholeCode
                    }).then(response => {
                        let pointsToAdd = response.data.item1;
                        this.points += pointsToAdd;
                        this.pointsAdded += pointsToAdd;
                        setTimeout(() => this.pointsAdded = 0, 3000);

                        let achievementToAddIds = response.data.item2;
                        for(let achievementId of achievementToAddIds)
                            this.userAchievementIds.push(achievementId);

                        this.first = '';
                        this.second = '';
                        this.third = '';
                        this.fourth = '';
                        this.fifth = '';
                        this.sixth = '';
                    }).catch(() => {
                        alert('Unos neuspješan. Neispravan (ili već unesen) kod ili nemaš dopuštenje.');
                        this.first = '';
                        this.second = '';
                        this.third = '';
                        this.fourth = '';
                        this.fifth = '';
                        this.sixth = '';
                        document.getElementsByClassName('user-app-code-input-field')[0].focus();
                    });
            },
            openSurveyModal: function(event) {
                this.eventForModal = event;
                this.surveyModalVisible = true;
            },
            submitSurvey: function(eventId, surveyData) {
                this.$axios.post(`${this.$API_URL}/user/submit-survey`, { eventId: eventId, surveyData: surveyData })
                    .then(response => {
                        this.surveyModalVisible = false;
                        this.eventsAvailableForSurvey.splice(this.eventsAvailableForSurvey.findIndex(event => event.id === eventId), 1);
                        this.points += response.data;
                        this.pointsAdded = response.data;
                        setTimeout(() => this.pointsAdded = 0, 3000);
                    }).catch(() => {
                        alert('Slanje ankete nije uspjelo (možda nemaš dopuštenje). Molimo te pokušaj ponovo.');
                    });
            },
            getAchievementUnlockedIcon: function(achievementName) {
                return require(`../../assets/app-icons/achievements/${achievementName.replace(/\s/g, '').replace(/!/g, '').replace(/\?/g, '').replace(/\./g, '').toLowerCase()}.png`);
            },
            getAchievementLockedIcon: function(achievementName) {
                return require(`../../assets/app-icons/achievements/${achievementName.replace(/\s/g, '').replace(/!/g, '').replace(/\?/g, '').replace(/\./g, '').toLowerCase()}-locked.png`);
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/user/points`).then(response => {
                this.points = response.data;
            });

            this.$axios.get(`${this.$API_URL}/achievements/all-achievements`).then(response => {
                this.achievements = response.data;
            });

            this.$axios.get(`${this.$API_URL}/user/fulfilled-achievement-ids`).then(response => {
                this.userAchievementIds = response.data;
            });

            this.$axios.get(`${this.$API_URL}/user/available-surveys`).then(response => {
                this.eventsAvailableForSurvey = response.data;
            });
        }
    }
</script>

<style scoped>

#user-app-prizes .prizes-title {
    padding-left: 20px;
    font-size: 22px;
    font-weight: 800;
    margin-top: 30px;
}

#user-app-prizes .user-points {
    display: block;
    margin-top: 50px;
    font-size: 64px;
    font-weight: 800;
    line-height: 76px;
    text-align: center;
    opacity: 0.87;
    color: #30cec1;
}

#user-app-prizes .enter-code {
    font-size: 15px;
    line-height: 17px;
    text-align: center;
    color: black;
    opacity: 0.87;
    margin-top: 20px;
}

#user-app-prizes .prize-code-inputs {
    margin-top: 10px;
    display: flex;
    justify-content: center;
}

#user-app-prizes input {
    width: 40px;
    border: none;
    opacity: 0.34;
    border-radius: 4px;
    background-color: #D8D8D8;
    margin-right: 5px;
    font-size: 26px;
    text-align: center;
    color: black;
    font-weight: 700;
    padding: 6px 3px;
}

#user-app-prizes .added-points {
    text-align: center;
    margin-top: 5px;
    color: #30cec1;
    opacity: 0.87;
    font-size: 14px;
    line-height: 17px;
}

#user-app-prizes .subtitle {
    font-size: 16px;
    font-weight: 800;
    letter-spacing: -0.21px;
    line-height: 19px;
    padding-left: 20px;
    margin-top: 30px;
    margin-bottom: 10px;
}

#user-app-prizes .achievements-wrapper {
    display: flex;
    overflow-x: auto;
    height: 215px;
    padding-left: 20px;
}

#user-app-prizes .achievements-wrapper::after {
	content: '';
	flex: 0 0 10px;
}

#user-app-prizes .achievements-wrapper .achievement-box {
    flex: 0 0 160px;
    padding: 10px;
    box-shadow: 0 4px 12px 0 rgba(0,0,0,0.06);
    border-radius: 8px;
    background-color: rgba(0,0,0,0.03);
    margin-right: 10px;
    display: flex;
    flex-direction: column;
}

#user-app-prizes .achievements-wrapper .achievement-box img.fulfilled-mark,
#user-app-prizes .achievements-wrapper .achievement-box img.achievement-star {
    filter: invert(78%) sepia(9%) saturate(3087%) hue-rotate(121deg) brightness(92%) contrast(83%);
}

#user-app-prizes .achievements-wrapper .achievement-box img.fulfilled-mark {
    height: 15px;
}

#user-app-prizes .achievements-wrapper .achievement-box img.achievement-star { 
    height: 100%;
}

#user-app-prizes .achievements-wrapper .is-fulfilled {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 30px;
    margin-top: 10px;
    padding-right: 10px;
}

#user-app-prizes .achievements-wrapper .achievement-box .achievement-points {
    margin-top: auto;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

#user-app-prizes .achievements-wrapper .achievement-box .achievement-name {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 5px;
}

#user-app-prizes .achievements-wrapper .achievement-box .achievement-description {
    font-size: 14px;
}

#user-app-prizes .achievements-wrapper .achievement-box .achievement-points img {
    margin-right: 5px;
}

#user-app-prizes .achievements-wrapper .achievement-box .fulfilled-mark {
    display: none;
}

#user-app-prizes .achievements-wrapper .achievement-box.fulfilled {
    background-color: rgba(48,206,193, 0.1);
}

#user-app-prizes .achievements-wrapper .achievement-box.fulfilled .achievement-name,
#user-app-prizes .achievements-wrapper .achievement-box.fulfilled .achievement-description,
#user-app-prizes .achievements-wrapper .achievement-box.fulfilled .achievement-points {
    opacity: 0.5;
}

#user-app-prizes .achievements-wrapper .achievement-box.fulfilled .fulfilled-mark {
    display: block;
}

#user-app-prizes .achievements-wrapper .achievement-box img.unlocked-icon,
#user-app-prizes .achievements-wrapper .achievement-box img.locked-icon {
    height: 35px;
    width: 35px;
    margin-bottom: 5px;
    margin-right: auto;
    display: none;
}

#user-app-prizes .achievements-wrapper .achievement-box.not-fulfilled img.locked-icon {
    display: block;
} 

#user-app-prizes .achievements-wrapper .achievement-box.fulfilled img.unlocked-icon {
    display: block;
} 

#user-app-prizes .prizes-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

#user-app-prizes .prizes-wrapper .prize {
    flex-basis: 40%;
    margin-right: 5px;
    height: 150px;
    margin-top: 20px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

#user-app-prizes .prizes-wrapper .prize img {
    height: 100px;
    max-width: 100%;
}

#user-app-prizes .event-for-survey {
    background-color: rgba(0,0,0,0.03);
    padding: 10px;
    border-radius: 4px;
    margin: 5px;
}

#user-app-prizes .event-for-survey:hover {
    cursor: pointer;
}
</style>